// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import config from './config'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'

import VueAuth from '@websanova/vue-auth'
import VueAuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x.js'

import i18n from './config/i18n'
import VueHead from 'vue-head'
import VeeValidate from 'vee-validate'
// eslint-disable-next-line no-duplicate-imports
import { Validator } from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import fa from 'vee-validate/dist/locale/fa'
import it from 'vee-validate/dist/locale/it'
import es from 'vee-validate/dist/locale/es'
import zh from 'vee-validate/dist/locale/zh_CN'

import Global, { setReferralCode, getReferralCode } from './plugins/global'
import Toasted from 'vue-toasted'
import VTooltip from 'v-tooltip'
import VueGtag from 'vue-gtag'
import scaleDirective from '@/directives/scaleDirective'
import closableDirective from '@/directives/closableDirective'
import DisableAutocomplete from './utils/preventAutocomplete'
import mobileRows from '@/mixins/mobileRows';

import { VueReCaptcha } from 'vue-recaptcha-v3'

import VueApexCharts from 'vue-apexcharts'

require('moment/locale/fa.js')
require('moment/locale/es.js')
require('moment/locale/en-gb.js')

Vue.use(VueApexCharts)
Vue.use(DisableAutocomplete)

Vue.component('apexchart', VueApexCharts)

Vue.directive('scale', scaleDirective)
Vue.directive('closable', closableDirective)

Vue.mixin(mobileRows);

Vue.use(
  VueGtag,
  {
    config: { id: 'GTM-5B8SP2B' },
  },
  router
)

Vue.use(VueAxios, axios)
Vue.use(VTooltip)
Vue.use(VueClipboard)
Vue.use(Global)
Vue.use(Toasted, {
  router,
  className: 'notification',
  duration: 5000,
  theme: 'toasted-primary',
})

Vue.use(VueHead, {
  separator: '|',
  complement: 'Plexytrade',
})
Vue.use(VeeValidate, {
  enableAutoClasses: true,
  classNames: {
    touched: 'touched',
    untouched: 'untouched',
    valid: 'is-success',
    invalid: 'invalid',
    pristine: 'pristine',
    dirty: 'dirty',
  },
})

Vue.prototype.$moment = moment

Vue.router = router

Vue.use(VueAuth, {
  http: VueAuthHttp,
  router: VueAuthRouter,
  auth: {
    request: function (req, token) {
      this.http.setHeaders.call(this, req, {
        Authorization: token,
      })
    },
    response: function (res) {
      axios.defaults.headers['Authorization'] = res.data.token
      _service.defaults.headers['Authorization'] = res.data.token
      if (typeof res.data.userID !== 'undefined') {
        store.commit('user/SET_USER_INFO', {
          ID: res.data.userID,
        })
      }
      return res.data.token
    },
  },
  fetchData: {
    url: config.API.host + 'authenticate/user',
  },
  stores: ['cookie', 'storage'],
  loginData: {
    url: `${config.API.host}authenticate/login?isClient=1${window.localStorage.getItem('campaign_name') ? `&campaign_name=${window.localStorage.getItem('campaign_name')}` : ''}`,
    method: 'GET',
    fetchUser: false,
    redirect: null,
  },
  logoutData: {
    redirect: window.localStorage.getItem('lang') ? '/' + window.localStorage.getItem('lang') + '/login' : '/en/login',
  },
  // Preserve IB `t` when an unauthenticated user hits an auth-protected route.
  // vue-auth redirects before App.vue can see the original URL, so capture here.
  // Once stored, redirect to login without keeping `t` in the URL.
  authRedirect: function (to) {
    const lang = window.localStorage.getItem('lang') || 'en'
    const referralCode = (to && to.query && to.query.t) || getReferralCode()
    if (referralCode) {
      setReferralCode(referralCode)
    }
    return {
      path: '/' + lang + '/login',
    }
  },
  refreshData: {
    enabled: false,
  },
  getCookieDomain: function () {
    return process.env.NODE_ENV === 'development' ? 'localhost' : 'plexytrade.com'
  },
  cookie: {
    Path: '/',
    Domain: null,
    Secure: false,
    Expires: 12096e5, // This means two weeks
    SameSite: 'Lax',
  },
})

Vue.use(VueReCaptcha, { siteKey: config.recaptchaSiteKey })

// Enable devtools
Vue.config.devtools = true

Vue.config.productionTip = false

axios.defaults.baseURL = config.API.host

// eslint-disable-next-line no-extend-native
String.prototype.tTitle = function () {
  if (this === '') {
    return this
  }
  return this[0].toUpperCase() + this.slice(1)
}
// eslint-disable-next-line no-extend-native
String.prototype.tUpper = function () {
  if (this === '') {
    return this
  }
  return this.toUpperCase()
}
// eslint-disable-next-line no-extend-native
String.prototype.tCapitalizeFirstLetter = function () {
  if (this === '') {
    return this
  }
  let lang = app.$store.state.lang
  return this.toLowerCase(lang)
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
// eslint-disable-next-line no-extend-native
String.prototype.tLower = function () {
  if (this === '') {
    return this
  }
  return this.toLowerCase()
}

const currencyFormat = {
  getMessage() {
    return i18n.t('only_currency_format_allowed')
  },
  validate(value) {
    if (value) {
      // return (/(?=.)^(([1-9][0-9]{0,2}(,[0-9]{3})*)|0)?(\.[0-9]{1,2})?$/.test(value))
      return /(?=.)^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{1,2})?$/.test(value)
    } else {
      return false
    }
  },
}

const minCurrencyValue = {
  getMessage(field, [min]) {
    return i18n.t('field_min_currency_value', {
      field: field,
      min: min,
    })
  },
  validate(value, [min]) {
    if (Array.isArray(value) || value === null || value === undefined || value === '') {
      return false
    }
    return Number(value.replace(',', '')) >= min
  },
}

const strongPassword = {
  getMessage() {
    return i18n.t('password_rules_extended')
  },
  validate: (value, [customValue = value]) => {
    if (value && customValue) {
      if (customValue === value) return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*<>+={}()?:;,.\\/|'"`_\-~[\]]).{6,15}$/.test(value)
      return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*<>+={}()?:;,.\\/|'"`_\-~[\]]).{6,15}$/.test(customValue)
    } else {
      return false
    }
  },
}

const multipleOf10 = {
  getMessage() {
    return i18n.t('must_be_multiple_of_10')
  },
  validate(value) {
    return value / 10 === Math.floor(value / 10)
  },
}

const emailAvailable = {
  getMessage() {
    return i18n.t('email_exists_message')
  },
  validate(value) {
    if (value) {
      return axios
        .post('/users/email-available', {
          email: value,
        })
        .then(response => {
          return {
            valid: response.data.available,
          }
        })
        .catch(() => {
          return false
        })
    } else {
      return false
    }
  },
}
const isIslamic = {
  getMessage() {
    return i18n.t('is_islamic_acc_message')
  },
  validate(value) {
    return value !== 'islamic'
  },
}
const isOver18 = {
  getMessage() {
    return i18n.t('must_be_over_18')
  },
  validate(year, args) {
    if (args.dob) {
      let now = moment()
      let dob = moment(args.dob, 'D-M-YYYY')

      return now.diff(dob, 'years') >= 18
    }

    return false
  },
}

const customConfirmPassword = {
  getMessage() {
    return i18n.t('passwords_must_match')
  },
  validate(value, args) {
    // If one of them is empty, don't validate yet
    if (!value || !args.password || !args['confirm-password']) {
      return true
    }

    return args.password === args['confirm-password']
  },
}

const customConfirmNewPassword = {
  getMessage() {
    return i18n.t('passwords_new_must_match')
  },
  validate(value, args) {
    // If one of them is empty, don't validate yet
    if (!value || !args.password || !args['confirm-password']) {
      return true
    }

    return args.password === args['confirm-password']
  },
}

const sufficientBalance = {
  getMessage() {
    return i18n.t('insufficient_balance')
  },
  validate(value, [balance]) {
    if (!value) return false
    const amount = Number(value)
    return amount <= balance
  },
}

if (window.localStorage) {
  let url = location.pathname.split('/')
  let lang = url[1]

  // Only supported languages from config
  const supportedLangs = config.languages
  if (lang && lang.length === 2) {
    if (!(lang in supportedLangs)) {
      // Force redirect to /en + rest of path
      const rest = url.slice(2).join('/') // everything after the lang segment
      const newPath = `/en/${rest}`
      window.localStorage.setItem('lang', 'en')
      store.commit('language/SET_LANGUAGE', 'en')
      i18n.locale = 'en'
      moment.locale('en')
      window.location.replace(newPath || '/en')
      // Important: stop executing further code
      throw new Error('Redirecting to /en')
    }

    // lang === 'en'
    window.localStorage.setItem('lang', lang)
    store.commit('language/SET_LANGUAGE', lang)
    i18n.locale = lang
    moment.locale(lang)
  } else {
    // No lang segment; default to en
    let fallbackLang = 'en'
    if (window.localStorage.getItem('lang')) {
      fallbackLang = window.localStorage.getItem('lang')
    }
    store.commit('language/SET_LANGUAGE', fallbackLang)
    i18n.locale = fallbackLang
    moment.locale(fallbackLang)
  }

  Validator.localize(store.getters['language/code'])

  window.localStorage.setItem('app-version', require('/public/static/auto-generated.json').version)
}

Validator.localize({
  fa,
  it,
  es,
  zh,
})

Validator.extend('min-currency-value', minCurrencyValue)
Validator.extend('currency', currencyFormat)
Validator.extend('strong-password', strongPassword)
Validator.extend('multiple-of-10', multipleOf10)
Validator.extend('email-available', emailAvailable)
Validator.extend('is-islamic', isIslamic)
Validator.extend('is-over-18', isOver18, {
  hasTarget: true,
  paramNames: ['dob'],
})
Validator.extend('custom-confirmed', customConfirmPassword, {
  hasTarget: true,
  paramNames: ['password', 'confirm-password'],
})
Validator.extend('custom-confirmed-new', customConfirmNewPassword, {
  hasTarget: true,
  paramNames: ['password', 'confirm-password'],
})
Validator.extend('sufficient-balance', sufficientBalance)

Vue.prototype.$locale = {
  change(language) {
    i18n.locale = language
    Validator.localize(i18n.locale)
    Validator.extend('min-currency-value', minCurrencyValue)
    Validator.extend('currency', currencyFormat)
    Validator.extend('strong-password', strongPassword)
    Validator.extend('multiple-of-10', multipleOf10)
    Validator.extend('email-available', emailAvailable)
    Validator.extend('is-islamic', isIslamic)
    Validator.extend('is-over-18', isOver18, {
      hasTarget: true,
      paramNames: ['dob'],
    })
    Validator.extend('custom-confirmed', customConfirmPassword, {
      hasTarget: true,
      paramNames: ['password', 'confirm-password'],
    })
    Validator.extend('custom-confirmed-new', customConfirmNewPassword, {
      hasTarget: true,
      paramNames: ['password', 'confirm-password'],
    })
    Validator.extend('sufficient-balance', sufficientBalance)
    moment.locale(language)
  },
  current() {
    return i18n.locale
  },
}

window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})

sync(store, router)

// event bus
const bus = new Vue()
Vue.prototype.$bus = bus

// check if the current window.location is matching any of the existing routes
const routes = router.options.routes
const isRouteMatched = routes.some(route => {
  return route.path === window.location.pathname || (route.path.endsWith('*') && window.location.pathname.startsWith(route.path.slice(0, -1)))
})

const app = new Vue({
  router,
  store,
  i18n,
  watch: {
    '$route.params.lang': {
      immediate: true,
      handler(lang) {
        if (lang && i18n.locale !== lang) {
          i18n.locale = lang
        }
      },
    },
    // watch the window.location and if the route matches with some of the existing routes but lang param is missing redirect to the correct route
    'window.location': {
      immediate: true,
      handler() {
        if (isRouteMatched && !window.location.pathname.includes(i18n.locale)) {
          window.location.href = `${window.location.origin}/${i18n.locale}${window.location.pathname}`
        }
      },
    },
  },
  render: h => h(App),
})

router.beforeEach((to, from, next) => {
  document.getElementsByTagName('body')[0].classList.remove('overflow-y-hidden')
  const IsItABackButton = window.popStateDetected
  window.popStateDetected = false
  if (IsItABackButton && from.path.includes('verify-email')) {
    Vue.toasted.clear() //clear toasted notifications on route change
    next(false)
    return ''
  }
  let localLang = window.localStorage.getItem('lang')
  if (!localLang) {
    localLang = 'en'
  }

  // Persist IB referral code as early as possible (before auth redirects / App.vue).
  if (to.query && to.query.t) {
    setReferralCode(to.query.t)
  }

  if (to.path === '/') {
    store.commit('language/SET_LANGUAGE', localLang)
    i18n.locale = localLang
    return
  }

  // delay the toasted notification when user is upgraded from DEMO to LIVE
  if (app) {
    const upgradeFlag = to.query.upgrade === 'true' || to.query.upgrade === true
    if (from.path.includes('/register/upgrade') && to.name === 'Dashboard' && upgradeFlag) {
      store.commit('logoLoader/SET_MANUAL_LOADER', false)
      setTimeout(() => {
        app.$toasted.success(app.$t('upgraded_to_a_live_account_successfully'))
        // app.$toasted.success(app.$t('password_generated_for_ta'))
      }, 2500)
    }
  }

  if (app && app.$auth.check() && app.$auth?.transitionPrev?.meta.auth === false) {
    const targetPath = '/' + localLang + '/'
    if (to.path !== targetPath) {
      Vue.toasted.clear() //clear toasted notifications before the route change
      next({ path: targetPath })
    } else {
      Vue.toasted.clear() //clear toasted notifications before the route change
      next() // Already at the target path
    }
  } else {
    Vue.toasted.clear() //clear toasted notifications before the route change
    next() // Proceed as usual if the condition is not met
  }

  Validator.localize(localLang)
  Vue.toasted.clear() //clear toasted notifications before the route change
  next()
})

router.afterEach(async to => {
  // The user is not yet stored in store
  if (app && !app.$store.state?.user?.client && to?.meta?.auth) {
    // get user details
    const userInfoResponse = await service.get(`/users/account-types/${app.$store.state.user.info.ID}`, null, 'getuserdetails')
    if (to.matched.some(record => record.meta.needsPrivileges)) {
      if (userInfoResponse.data.accountTypes.length) {
        let redirect = true
        for (let match of to.matched) {
          if (!match?.meta?.needsPrivileges) {
            continue
          }
          for (let i = 0, l = match.meta.needsPrivileges.length; i < l; i++) {
            if (userInfoResponse.data.accountTypes.indexOf(match.meta.needsPrivileges[i]) !== -1) {
              redirect = false
            }
          }
        }
        if (redirect) {
          router.push({
            path: '/' + i18n.locale + '/' + config.defaultURL,
          })
          return
        }
      }
    }
    // if the route is US restricted
    if (to.matched.some(record => record?.meta?.restrictedUS)) {
      if (userInfoResponse.data.country_code) {
        let redirect = true
        if (!config.eligibleCountriesTradingCompetition.includes(userInfoResponse.data.country_code)) {
          redirect = false
        }
        if (redirect) {
          router.push({
            path: '/' + i18n.locale + '/' + config.defaultURL,
          })
          return
        }
      }
    }
  }

  // SEO Meta Updates

  const lang = i18n.locale || 'en'

  app.addMeta('ogtitle', app.$t(to.meta.T).tTitle() + ' | ' + app.$t('app_name'))
  app.addMeta('description', app.$t(to.meta.description))
  app.addMeta('canonical', config.URL.cp + to.fullPath)
  app.addMeta('alternate', to.meta.identifierPath, lang)
  document.title = app.$t(to.meta.T).tTitle() + ' | ' + app.$t('app_name')
})

const _service = axios.create({
  baseURL: config.API.host,
  headers: {
    Authorization: app.$auth.token(),
  },
})

const service = {
  get(url, data, uid) {
    this._checkCreate(uid)
    let r = _service.get(url, data)
    r.then(() => {
      this._complete(uid)
    }).catch(() => {
      this._complete(uid)
    })
    return r
  },
  async post(url, data, uid) {
    this._checkCreate(uid)
    let r = _service.post(url, data)
    await r
      .then(() => {
        this._complete(uid)
      })
      .catch(() => {
        this._complete(uid)
      })
    return r
  },
  check(uid) {
    if (typeof store.getters['requests/all'][uid] !== 'undefined') {
      return store.getters['requests/all'][uid]
    }
    return false
  },
  _checkCreate(uid) {
    if (uid) {
      if (typeof store.getters['requests/all'][uid] === 'undefined') {
        let d = {
          completed: false,
        }
        store.dispatch('requests/add', {
          uid: uid,
          data: d,
        })
      } else if (store.getters['requests/all'][uid].completed) {
        let d = Object.create(store.getters['requests/all'][uid])
        d.completed = false
        store.dispatch('requests/edit', {
          uid: uid,
          data: d,
        })
      }
    }
  },
  _complete(uid) {
    if (uid) {
      let d = Object.create(store.getters['requests/all'][uid])
      d.completed = true
      store.dispatch('requests/edit', {
        uid: uid,
        data: d,
      })
    }
  },
}
_service.interceptors.request.use(
  function (config) {
    store.dispatch('logoLoader/incrementCalls') // Increment on each request
    return config
  },
  function (error) {
    store.dispatch('logoLoader/decrementCalls') // Decrement if request fails
    return Promise.reject(error)
  }
)

_service.interceptors.response.use(
  function (response) {
    store.dispatch('logoLoader/decrementCalls') // Decrement when response is received
    return response
  },
  function (error) {
    store.dispatch('logoLoader/decrementCalls') // Decrement if response fails
    if (error.response?.data?.status === 401 && app.$route.name !== 'Login') {
      app.$auth
        .logout({
          makeRequest: false,
          params: {},
          redirect: '/en/login',
        })
        .then(() => {
          store.commit('user/SET_USER_INFO', {})
        })
    }
    return Promise.reject(error)
  }
)

function createDeferredToast(originalToastedFunction, store) {
  return function (...args) {
    const showToastWithDelay = () => {
      setTimeout(() => {
        originalToastedFunction.apply(this, args)
      }, 350)
    }

    const delayToastUntilLoaderHidden = () => {
      const state = store.state.logoLoader
      if (!state.active && state.ongoingCalls === 0 && !state.manualLoader) {
        showToastWithDelay()
        return true
      }

      return false
    }

    Vue.nextTick(() => {
      if (delayToastUntilLoaderHidden()) return

      let waited = 0
      const maxWait = 10000
      const interval = setInterval(() => {
        waited += 200

        if (delayToastUntilLoaderHidden() || waited >= maxWait) {
          clearInterval(interval)
          if (waited >= maxWait) showToastWithDelay()
        }
      }, 200)
    })
  }
}

Vue.mixin({
  beforeCreate() {
    if (this.$toasted && this.$store && !this.$toasted.__wrapped) {
      const store = this.$store

      this.$toasted.success = createDeferredToast(this.$toasted.success, store)
      this.$toasted.error = createDeferredToast(this.$toasted.error, store)
      this.$toasted.show = createDeferredToast(this.$toasted.show, store)
      this.$toasted.__wrapped = true
    }
  },
})

// Avoids redundant error when navigating to already active page or same lang pages
Vue.mixin({
  routerPush(route) {
    this.$router.push(route).catch(error => {
      if (error.name != 'NavigationDuplicated') {
        throw error
      }
    })
  },
})

// Get active currencies
Vue.prototype.$getCurrencies = function (active = true) {
  let result = {}
  for (let currency in config.currencies) {
    let c = config.currencies[currency]
    if (c.active || !active) {
      result[currency] = c
    }
  }

  return result
}

export { app, router, store, service }

app.$mount('#app')
